import { BaseApi } from "@/api/index";

const baseUrl = process.env.REACT_APP_BACKEND_URL || "";

export interface CustomSiteSettings {
  id: number;

  title: string;
  support_email: string | null;
  primary_color: string | null;
  date_format: string | null;
  secondary_color: string | null;
  logo: string | File | null;

  created_date: string;
  updated_date: string | null;
  deleted_at: string | null;
  created_by: number;
  updated_by: number | null;
  deleted_by: number | null;
}

class CustomSiteSettingsApi<T = unknown> extends BaseApi<T> {
  constructor() {
    super({ apiBaseUrl: baseUrl, base: "api/custom_site_settings" });
  }
}

export const customSiteSettingsApi =
  new CustomSiteSettingsApi<CustomSiteSettings>();
